<script>
import { gridMixin } from '@mixins/grid-mixin';

export default {
  components: {},
  mixins: [gridMixin],
  props: {
    day: {
      type: Object,
      required: true,
      default: () => {},
    },
    mealtime: {
      type: Object,
      required: true,
      default: () => {},
    },
    leftovers: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
    };
  },
  computed: {
    groupedDishes() {
      const leftoverDishes = this.leftovers.map((leftover) => {
        return {
          ...leftover.recipe,
          platelistDayId: leftover.platelistDayId,
          platelistMealId: leftover.platelistMealId,
          recipeId: leftover.recipeId,
          useLeftovers: leftover.useLeftovers,
        };
      });

      const dishes =
        this.mealtime &&
        this.mealtime.meals
          .concat(this.mealtime.recipes)
          .concat(leftoverDishes);
      return this.getGridGroups(dishes, 2);
    },
    moreThanOne() {
      return (
        this.mealtime &&
        this.mealtime.meals.concat(this.mealtime.recipes).concat(this.leftovers)
          .length > 1
      );
    },
  },
  methods: {
    manageRecipe(recipe, day, mealtime) {
      this.$emit('manage-recipe', { recipe, day, mealtime });
    },
  },
};
</script>

<template>
  <div :class="['dishes-slot', { 'dishes-slot-multi': moreThanOne }]">
    <div :class="['list-group', { 'list-group-multi': moreThanOne }]">
      <div
        :class="[
          'row list-group-child',
          { 'list-group-child-multi': moreThanOne },
        ]"
        :key="i"
        v-for="(dishes, i) in groupedDishes"
      >
        <div
          class="dish-image"
          v-for="(dish, index) in dishes"
          :key="index"
          :style="
            `backgroundImage: url(${dish.imageUrl ||
              dish.imageURL ||
              dish.imageurl ||
              placeholder})`
          "
          @click="manageRecipe(dish, day, mealtime)"
        >
          <div class="triangle" v-if="dish.hasLeftovers || dish.useLeftovers">
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="dish.hasLeftovers" v-bind:class="'icon-make-leftovers'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.786 14.962c3.623 0 6.624-3.001 6.624-6.631 0-2.146-1.073-4.108-2.707-5.305-.307-.239-.683-.17-.861.103-.192.287-.103.615.178.834a5.426 5.426 0 012.214 4.368 5.424 5.424 0 01-5.448 5.448 5.422 5.422 0 01-5.441-5.448 5.418 5.418 0 014.163-5.298v.937c0 .465.335.594.704.335L8.317 2.82c.301-.218.308-.547 0-.765L6.22.572c-.376-.266-.711-.136-.711.335v.923C2.479 2.432.155 5.146.155 8.331c0 3.63 3.008 6.63 6.631 6.63zM3.457 5.993c-.027.294-.055.588-.055.868 0 2.215 1.456 3.91 3.343 3.91.827 0 1.593-.355 1.928-.957.294.39.437.848.683 1.566.021.068.096.096.15.061l.226-.109c.164-.068.226-.164.226-.335 0-.478-.615-1.196-.93-1.483C7.702 8.29 5.658 9 5.166 7.654a.157.157 0 01-.02-.061c0-.055.04-.096.082-.096.047 0 .075.027.109.062 1.012 1.011 2.42.164 3.698 1.353.103.082.233.055.24-.068.013-.103.02-.219.02-.349 0-1.483-1.046-2.112-2.543-2.112-.472 0-.95.061-1.395.061-.628 0-1.189-.109-1.572-.526-.116-.116-.307-.096-.328.075z" fill="#fff"/></svg>
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="dish.useLeftovers" v-bind:class="'icon-use-leftovers'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.786 14.962c3.623 0 6.624-3.001 6.624-6.631 0-2.146-1.073-4.108-2.707-5.305-.307-.239-.683-.17-.861.103-.192.287-.103.615.178.834a5.426 5.426 0 012.214 4.368 5.424 5.424 0 01-5.448 5.448 5.422 5.422 0 01-5.441-5.448 5.418 5.418 0 014.163-5.298v.937c0 .465.335.594.704.335L8.317 2.82c.301-.218.308-.547 0-.765L6.22.572c-.376-.266-.711-.136-.711.335v.923C2.479 2.432.155 5.146.155 8.331c0 3.63 3.008 6.63 6.631 6.63zM3.457 5.993c-.027.294-.055.588-.055.868 0 2.215 1.456 3.91 3.343 3.91.827 0 1.593-.355 1.928-.957.294.39.437.848.683 1.566.021.068.096.096.15.061l.226-.109c.164-.068.226-.164.226-.335 0-.478-.615-1.196-.93-1.483C7.702 8.29 5.658 9 5.166 7.654a.157.157 0 01-.02-.061c0-.055.04-.096.082-.096.047 0 .075.027.109.062 1.012 1.011 2.42.164 3.698 1.353.103.082.233.055.24-.068.013-.103.02-.219.02-.349 0-1.483-1.046-2.112-2.543-2.112-.472 0-.95.061-1.395.061-.628 0-1.189-.109-1.572-.526-.116-.116-.307-.096-.328.075z" fill="#fff"/></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.dishes-slot {
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  padding-top: 5rem;

  &::-webkit-scrollbar {
    display: none;
  }

  &.dishes-slot-multi {
    height: auto;
  }

  .list-group {
    display: flex;
    flex-direction: normal;
    flex-wrap: wrap;
    height: 100%;
    justify-content: center;
    padding: 0 1.5rem;
    position: relative;
    top: -4.8rem;
    width: 100%;

    &.list-group-multi {
      top: unset;
    }

    &::after {
      content: '';
      flex: auto;
    }

    .list-group-child {
      left: 1.7rem;
      position: absolute;

      &.list-group-child-multi {
        position: relative;
      }
    }
  }

  .dish-image {
    align-self: flex-start;
    background-position: center;
    background-size: cover;
    border-radius: $base-border-radius-md;
    display: flex;
    height: 6rem;
    margin-bottom: 1.7rem;
    width: 6rem;

    &:nth-child(even) {
      margin-left: 2rem;
    }

    &:hover {
      cursor: pointer;
    }

    .triangle {
      border-bottom: solid 30px $color-medium-gray;
      border-bottom-left-radius: $base-border-radius-md;
      border-bottom-right-radius: $base-border-radius-md;
      border-left: solid 30px transparent;
      border-right: solid 30px $color-medium-gray;
      border-top: solid 30px transparent;
      border-top-right-radius: $base-border-radius-md;
      box-sizing: border-box;

      .icon-make-leftovers {
        height: 2rem;
        position: absolute;
        width: 2rem;
      }
      .icon-use-leftovers {
        height: 2rem;
        position: absolute;
        width: 2rem;
        path {
          fill: green;
        }
      }
    }
  }
}
</style>
